import fetch from "auth/FetchInterceptor";

const AssignmentService = {};

const assignmentPrefix = "/assignments";
const submissionPrefix = "/submissions";

AssignmentService.getFormationAssignments = async (formationId) =>
  await fetch(`${assignmentPrefix}/formation/${formationId}`, {
    method: "GET",
  });

AssignmentService.getFormationStructure = async (formationId) =>
  await fetch(`${assignmentPrefix}/formation/${formationId}/structure`, {
    method: "GET",
  });

AssignmentService.getCourseAssignments = async (courseId) =>
  await fetch(`${assignmentPrefix}/course/${courseId}`, {
    method: "GET",
  });

AssignmentService.getCourseStructure = async (courseId) =>
  await fetch(`${assignmentPrefix}/course/${courseId}/structure`, {
    method: "GET",
  });

AssignmentService.getAssignment = async (id) =>
  await fetch(`${assignmentPrefix}/${id}`, {
    method: "GET",
  });

AssignmentService.createAssignment = async (formData) =>
  await fetch(`${assignmentPrefix}`, {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

AssignmentService.updateAssignment = async (id, formData) =>
  await fetch(`${assignmentPrefix}/${id}`, {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

AssignmentService.deleteAssignment = async (id) =>
  await fetch(`${assignmentPrefix}/${id}`, {
    method: "DELETE",
  });

AssignmentService.toggleSolution = async (id, solutionVisible) =>
  await fetch(`${assignmentPrefix}/${id}/toggle-solution`, {
    method: "PATCH",
    data: { solutionVisible },
  });

AssignmentService.togglePublish = async (id, isPublished) =>
  await fetch(`${assignmentPrefix}/${id}/toggle-publish`, {
    method: "PATCH",
    data: { isPublished },
  });

AssignmentService.getAssignmentSubmissions = async (assignmentId) =>
  await fetch(`${submissionPrefix}/assignment/${assignmentId}`, {
    method: "GET",
  });

AssignmentService.reviewSubmission = async (id, formData) =>
  await fetch(`${submissionPrefix}/${id}/review`, {
    method: "PATCH",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export default AssignmentService;
